import React from 'react';

import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import ActionButton from 'components/action-button';
import { useOffersContext } from 'state/offers';
import { routes } from 'utils/routing';

import {
  ButtonContainer,
  ButtonLabel,
  Container,
  Text,
  Title,
} from './menu-item-unavailable.styled';
import { IItemUnavailableData, MenuItemUnavailableProps } from './types';

const MenuItemUnavailable: React.FC<MenuItemUnavailableProps> = ({ isOffer }) => {
  const { formatMessage } = useIntl();
  const { selectedOffer, clearSelectedOffer } = useOffersContext();
  const navigate = useNavigate();

  const backToMenu = () => navigate(routes.menu);
  const backToOffers = () => {
    if (selectedOffer) {
      clearSelectedOffer({ popToast: true });
    }
    navigate(routes.offers);
  };

  const menuItemUnavailableData: IItemUnavailableData = isOffer
    ? {
        title: 'offerNotAvailable',
        content: 'chooseDifferentOffer',
        buttonLabel: 'backToOffers',
        cta: backToOffers,
      }
    : {
        title: 'itemNotAvailable',
        content: 'chooseDifferentItem',
        buttonLabel: 'backToMenu',
        cta: backToMenu,
      };

  const { title, content, buttonLabel, cta } = menuItemUnavailableData;

  return (
    <Container>
      <Title data-testid="menu-item-unavailable-title">{formatMessage({ id: title })}</Title>
      <Text>
        {formatMessage({ id: 'selectionNotAvailable' })} <br />
        {formatMessage({ id: content })}
      </Text>

      <ButtonContainer>
        <ActionButton data-testid="menu-item-unavailable-cta" fullWidth onClick={cta}>
          <ButtonLabel>{formatMessage({ id: buttonLabel })}</ButtonLabel>
        </ActionButton>
      </ButtonContainer>
    </Container>
  );
};

export default MenuItemUnavailable;
